import { render, staticRenderFns } from "./ApplicantsSelectionValiev.vue?vue&type=template&id=32057f80&"
import script from "./ApplicantsSelectionValiev.vue?vue&type=script&lang=js&"
export * from "./ApplicantsSelectionValiev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports